<template>
	<div class="bodily">
		<h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">产前的体型信息</h3>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			ref="bodily"
		>
			<el-form-item
				label="身高:"
				label-width="0.56rem"
				prop="height"
			>
				<el-input
					v-model="formData.height"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="体重:"
				label-width="0.42rem"
				prop="weight"
			>
				<el-input
					v-model="formData.weight"
					placeholder="请输入"
				></el-input>
				kg
			</el-form-item>
			
			<el-form-item
				label="胸围:"
				label-width="0.56rem"
				prop="bust"
			>
				<el-input
					v-model="formData.bust"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="腰围:"
				label-width="0.56rem"
				prop="waist"
			>
				<el-input
					v-model="formData.waist"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="臀围:"
				label-width="0.42rem"
				prop="hip"
			>
				<el-input
					v-model="formData.hip"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="体脂率:"
				label-width="0.56rem"
				prop="fat"
			>
				<el-input
					v-model="formData.fat"
					placeholder="请输入(选填)"
				></el-input>
				%
			</el-form-item>
			
			<h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">产后的体型信息</h3>
			
			<el-form-item
				label="孕周数:"
				label-width="0.56rem"
				prop="preweek"
			>
				<el-input
					v-model="formData.preweek"
					placeholder="请输入"
				></el-input>
				周
			</el-form-item>
			
			<el-form-item
				label="体重:"
				label-width="0.42rem"
				prop="preweight"
			>
				<el-input
					v-model="formData.preweight"
					placeholder="请输入"
				></el-input>
				kg
			</el-form-item>
			
			<el-form-item
				label="胸围:"
				label-width="0.56rem"
				prop="prebust"
			>
				<el-input
					v-model="formData.prebust"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="腰围:"
				label-width="0.56rem"
				prop="prewaist"
			>
				<el-input
					v-model="formData.prewaist"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="臀围:"
				label-width="0.42rem"
				prop="prehip"
			>
				<el-input
					v-model="formData.prehip"
					placeholder="请输入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="体脂率:"
				label-width="0.56rem"
				prop="prefat"
			>
				<el-input
					v-model="formData.prefat"
					placeholder="请输入(选填)"
				></el-input>
				%
			</el-form-item>
			
			<el-form-item class="qjc-wid-100 qjc-texta-c">
				<el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button>
			</el-form-item>
			
		</el-form>
		
	</div>
</template>

<script>
	export default{
		name: "bodily",
		data() {
			var heightVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 130 || value > 200){
					callback(new Error('身高为130~200'));
				}else{
					callback();
				}
			}
			var weightVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 30 || value > 160){
					callback(new Error('体重为30~160'));
				}else{
					callback();
				}
			}
			var bustVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 40 || value > 150){
					callback(new Error('胸围为40~150'));
				}else{
					callback();
				}
			}
			var waistVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 40 || value > 150){
					callback(new Error('腰围为40~150'));
				}else{
					callback();
				}
			}
			var hipVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 60 || value > 165){
					callback(new Error('臀围为60~165'));
				}else{
					callback();
				}
			}
			var fatVerify = (rule, value, callback) => {
				if(isNaN(value) || value && value < 3 || value > 75){
					callback(new Error('体脂率为3~75'));
				}else{
					callback();
				}
			}
			
			return {
				rules: {
					// 产前
					height: [
						{ required: true, message: '请填写您的身高', trigger: 'blur' },
						{ validator: heightVerify, trigger: 'blur' }
					],
					weight: [
						{ required: true, message: '请填写您的体重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					bust: [
						{ required: true, message: '请填写您的胸围', trigger: 'blur' },
						{ validator: bustVerify, trigger: 'blur' }
					],
					waist: [
						{ required: true, message: '请填写您的腰围', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					hip: [
						{ required: true, message: '请填写您的臀围', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					fat: [
						{ validator: fatVerify, trigger: 'blur' }
					],
					
					// 产后
					preweek: [
						{ required: true, message: '请填写您的孕周数', trigger: 'blur' }
					],
					preweight: [
						{ required: true, message: '请填写您的体重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					prebust: [
						{ required: true, message: '请填写您的胸围', trigger: 'blur' },
						{ validator: bustVerify, trigger: 'blur' }
					],
					prewaist: [
						{ required: true, message: '请填写您的腰围', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					prehip: [
						{ required: true, message: '请填写您的臀围', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					prefat: [
						{ validator: fatVerify, trigger: 'blur' }
					]
				},
				
			}
		},
		props: ['formData'],
		methods: {
			//下一步
			next() {
				this.$refs.bodily.validate((isSuc, err) => {
					if(isSuc){
						this.$emit('checkTab', 'Newborn');
					}
				});
			},
		}
	}
</script>

<style scoped>
	.bodily >>> .el-form-item__label{
		font-size: 0.14rem;
		color: #777F8F;
		padding-right: 0;
		text-align: left;
	}
	.bodily >>> .el-input{
		width: 2.4rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.bodily >>> .el-input input{
		width: 2.4rem;
		height: 0.32rem;
		font-size: 0.14rem;
		line-height: 0.14rem;
		padding: 0.09rem 0.12rem;
	}
	.bodily >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		display: none;
	}
	.bodily >>> .el-form-item__content{
		font-size: 0.14rem;
	}
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 0.32rem;
		
		.el-form{
			h3{
				margin-top: 0.4rem;
			}
			
			.el-form-item{
				width: 33.33%;
				margin: 0.24rem 0 0 0;
				
				&.qjc-wid-100{
					width: 100%;
				}
				.next{
					width: 2rem;
					height: 0.48rem;
					margin-top: 0.24rem;
				}
			}
		}
		
	}
</style>
